module.exports = __webpack_public_path__ + "static/media/dungeon.c093093b.png";